import { Component, inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/base/base.component';
import { PageConfigurationProvider } from '@app/finxone-web-frontend/app/Modules/zones/page-configuration.provider';
import {
  SetCopResponseStateMatchStatusCode,
  SetCopResponseStateName,
} from '@app/finxone-web-frontend/app/lib/actions/cop-response.action';
import { AccountService } from '@app/finxone-web-frontend/app/lib/services/account-service/account-service.service';
import {
  CheckPayeeResponse,
  Payee,
} from '@app/finxone-web-frontend/app/lib/services/account-service/account.type';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { CountriesCurrenciesService } from '@app/finxone-web-frontend/app/lib/services/countries-currencies-service/countries-currencies.service';
import { FormSubmissionService } from '@app/finxone-web-frontend/app/lib/services/form-submission-service/form-submission-service.service';
import {
  AccountState,
  AccountStateModel,
  PaymentGatewayConfig,
} from '@app/finxone-web-frontend/app/lib/state/account.state';
import {
  FormActionState,
  FormActionType,
} from '@app/finxone-web-frontend/app/lib/state/form-submision.state';
import { ProjectSettingsState } from '@app/finxone-web-frontend/app/lib/state/project-settings.state';
import {
  buildHandleBarModel,
  filterIfHandlebarNotRendered,
} from '@app/finxone-web-frontend/app/lib/utils/template/model-builder.utils';
import { addDashesToSortCode } from '@app/finxone-web-frontend/app/lib/utils/template/string.utils';
import { formatNameAsUrl } from '@app/finxone-web-frontend/app/lib/utils/zone-url.utils';
import { FormActionTypeEnum, OtpParam } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AlertHandlerService, IconCacheService } from '@finxone-platform/shared/services';
import {
  ACCOUNTTYPE,
  APP_ZONES,
  BaseCssProperties,
  CheckPayeeMatchStatus,
  PaymentFlowTypes,
  ProviderClass,
  baseCssConfigStyle,
  buttonNestedWidgetConfigStyles,
  cssToNgStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import Handlebars from 'handlebars';
import {
  Observable,
  Subject,
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  takeUntil,
  throwError,
} from 'rxjs';
import { setNoMatchReasonFromResponse } from '@app/finxone-web-frontend/app/Modules/shared/widgets/add-beneficiary-v2/beneficiary-v2.utils';
import { PARENT_FORM_ROW_GAP } from '@app/finxone-web-frontend/app/lib/utils/di-tokens';
import { GetBeneficiaryRequiredFieldsAction } from '@app/finxone-web-frontend/app/lib/actions/beneficiary.action';
interface AddBeneficiaryFormType {
  name?: FormControl<string>;
  firstName?: FormControl<string>;
  lastName?: FormControl<string>;
  accountNumber: FormControl<string>;
  sortCode: FormControl<string>;
  srd?: FormControl<string>;
}
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-add-beneficiary-ukfp',
  templateUrl: './add-beneficiary-ukfp.component.html',
  styleUrls: ['./add-beneficiary-ukfp.component.scss'],
})
export class AddBeneficiaryUkfpComponent extends BaseComponent implements OnInit {
  @Input() formActionStateData: { [key: string]: string };
  @Input() dynamicZone = false;
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  public buttonContent = '';
  public addBeneficiaryForm: FormGroup<AddBeneficiaryFormType>;
  payeeEnabled: boolean;
  @Select(AccountState.getAccounts)
  private accounts!: Observable<AccountStateModel>;
  @Select(FormActionState.getFormActionStateWithId(FormActionTypeEnum.ADD_BENEFICIARY))
  formAction!: Observable<FormActionType>;
  accountId: string;
  public beneficiaryType: string;
  public ACCOUNTTYPE = ACCOUNTTYPE;
  public submitButtonStyle: baseCssConfigStyle = {};
  public enableBeneficiaryFirstAndLastName = false;
  public sortCode: string;
  public accountNumber: string;
  public name: string;
  public lastName?: string;
  public firstName?: string;
  public isAllowedGlobalStyling = false;
  public globalStylingClass = '';
  public colorTextAlignStyle: baseCssConfigStyle;
  private srd: string;
  public renderedContent = '';

  public parentFormWidgetRowGap: string | undefined | null = inject(PARENT_FORM_ROW_GAP, { optional: true });

  constructor(
    private fb: FormBuilder,
    public pageConfig: PageConfigurationProvider,
    public dataIn: ProviderClass<any>,
    private configService: ConfigService,
    private store: Store,
    private accountService: AccountService,
    private router: Router,
    private alertHandlerService: AlertHandlerService,
    public formSubmissionService: FormSubmissionService,
    private countriesCurrenciesService: CountriesCurrenciesService,
    private iconCacheService: IconCacheService,
  ) {
    super();
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [
      BaseCssProperties.BORDER,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
    ]);
    this.colorTextAlignStyle = this.configService.getSpecificBaseCssStyle(this.dataIn.attri, [
      BaseCssProperties.FONT_SIZE,
      BaseCssProperties.TEXT_BOLD,
      BaseCssProperties.TEXT_ITALIC,
      BaseCssProperties.TEXT_UNDERLINE,
      BaseCssProperties.COLOR,
      BaseCssProperties.TEXT_FONT_STYLE,
    ]);
    this.beneficiaryType = this.dataIn.attri.widgetProperties['beneficiaryType'];
    this.submitButtonStyle = this.configService.getSpecificBaseCssStyle(
      this.getNestedWidgetConfig(dataIn, 'submitButton'),
      buttonNestedWidgetConfigStyles,
    );

    this.enableBeneficiaryFirstAndLastName = this.store.selectSnapshot(
      ProjectSettingsState.getProjectSettings,
    ).enableBeneficiaryFirstAndLastName;
    this.getFormValuesFromState();
    this.buildForm();
    this.accounts
      .pipe(
        debounceTime(500),
        takeUntil(this.destroy$),
        map((account) => {
          this.accountId = account.currentAccountId;
        }),
        catchError((error) => {
          this.alertHandlerService.showAlertFn('error', error.error.message);
          return throwError(() => error);
        }),
      )
      .subscribe();
  }

  private buildForm() {
    const commonControls = {
      accountNumber: new FormControl(this.accountNumber, {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(8),
          Validators.pattern(/^(?!0+$)\d+$/),
        ],
      }),
      sortCode: new FormControl(this.sortCode, {
        nonNullable: true,
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(8),
          Validators.pattern(/^(?!00-00-00$)(\d{2}-\d{2}-\d{2})$/),
        ],
      }),
      srd: new FormControl(this.srd, {
        nonNullable: true,
      }),
    };

    if (
      !this.enableBeneficiaryFirstAndLastName ||
      (this.enableBeneficiaryFirstAndLastName && this.beneficiaryType === ACCOUNTTYPE.BUSINESS)
    ) {
      this.addBeneficiaryForm = this.fb.group<AddBeneficiaryFormType>({
        name: new FormControl(this.name, {
          nonNullable: true,
          validators: [Validators.required, Validators.pattern(/^[A-Za-z\s-.’]+$/)],
        }),
        ...commonControls,
      });
    } else if (this.enableBeneficiaryFirstAndLastName && this.beneficiaryType === ACCOUNTTYPE.PERSONAL) {
      this.addBeneficiaryForm = this.fb.group<AddBeneficiaryFormType>({
        firstName: new FormControl(this.firstName ?? '', {
          nonNullable: true,
          validators: [Validators.required, Validators.pattern(/^[A-Za-z\s-.’]+$/)],
        }),
        lastName: new FormControl(this.lastName ?? '', {
          nonNullable: true,
          validators: [Validators.required, Validators.pattern(/^[A-Za-z\s-.’]+$/)],
        }),
        ...commonControls,
      });
    }
  }

  ngOnInit() {
    if (this.dynamicZone && this.formActionStateData !== undefined) {
      this.patchAddBeneficiaryForm();
      this.editBeneficiaries();
    }
    this.onLoadWidgetContent();
    this.onGetPaymentGateway();
    this.getGlobalStyling();
    this.valueChangesTrigger();
  }

  private onLoadWidgetContent(): void {
    this.buttonContent =
      this.dataIn.widgetConfig?.nestedWidgets?.['submitButton'].widgetProperties.textContent ?? 'Proceed';
    const template = Handlebars.compile(this.buttonContent);
    buildHandleBarModel(
      this.store,
      this.buttonContent,
      this.countriesCurrenciesService,
      this.iconCacheService,
      this.accountService,
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe((model) => {
        this.renderedContent = filterIfHandlebarNotRendered(template(model));
      });
  }

  private valueChangesTrigger() {
    this.addBeneficiaryForm.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300), takeUntil(this.destroy$))
      .subscribe((values) => {
        if (this.dynamicZone) {
          this.editBeneficiaries();
        }
      });
  }

  private getGlobalStyling() {
    if (
      this.dataIn.widgetConfig.nestedWidgets?.['submitButton'].widgetProperties?.['globalStylingClass'] &&
      this.dataIn.widgetConfig.nestedWidgets?.['submitButton'].widgetProperties?.['globalStyling']
    ) {
      this.globalStylingClass =
        this.dataIn.widgetConfig.nestedWidgets?.['submitButton'].widgetProperties?.['globalStylingClass'] ??
        '';
      this.isAllowedGlobalStyling =
        this.dataIn.widgetConfig.nestedWidgets?.['submitButton'].widgetProperties?.['globalStyling'] ?? false;
    }
  }

  private onGetPaymentGateway(): void {
    this.store
      .selectOnce(AccountState.getPaymentGatewayConfig)
      .pipe(
        map((paymentGatewayConfig: PaymentGatewayConfig) => {
          this.payeeEnabled = paymentGatewayConfig?.checkPayeeEnabled;
        }),
      )
      .subscribe();
  }

  public onAddBeneficiaryformSubmit() {
    if (this.addBeneficiaryForm.valid) {
      this.setAddBeneficiaryFormState();
      this.copCheck(OtpParam.AddBeneficiary);
    } else {
      this.alertHandlerService.showAlertFn(
        'error',
        'Please make sure all the necessary details are provided.',
      );
    }
  }

  private setAddBeneficiaryFormState() {
    const fullNameValue = `${this.addBeneficiaryForm.value?.firstName ?? ''} ${
      this.addBeneficiaryForm.value?.lastName ?? ''
    }`.trim();
    const sortCode = this.formatSortCode();
    this.formSubmissionService.submitIndividualForm(
      {
        name: this.addBeneficiaryForm.value?.name ?? fullNameValue,
        accountType: this.beneficiaryType,
        accountId: this.accountId,
        destinationIdentifier: {
          accountNumber: this.addBeneficiaryForm.value.accountNumber,
          sortCode: sortCode,
          currency: 'GBP',
          country: 'GB',
        },
      },
      '',
      FormActionTypeEnum.ADD_BENEFICIARY,
    );

    this.store.dispatch(new GetBeneficiaryRequiredFieldsAction('GB', 'GBP'));
  }

  private editBeneficiaries() {
    const fullNameValue = `${this.addBeneficiaryForm.value?.firstName ?? ''} ${
      this.addBeneficiaryForm.value?.lastName ?? ''
    }`.trim();

    const sortCode = this.formatSortCode();
    const payload = {
      accountType: this.formActionStateData?.['accountType'],
      //currency: this.formActionStateData?.['currency'],
      bankId: this.formActionStateData?.['bankId'],
      id: this.formActionStateData?.['bid'],
      //sortCode: sortCode,
      name: this.addBeneficiaryForm?.get('name')?.value ?? fullNameValue,
      //accountNumber: this.addBeneficiaryForm?.get('accountNumber')?.value,
      destinationIdentifier: {
        accountNumber: this.addBeneficiaryForm?.get('accountNumber')?.value,
        sortCode: sortCode,
        currency: this.formActionStateData?.['currency'],
        id: this.formActionStateData?.['bankId'],
      },
    };
    const formObject = this.addBeneficiaryForm.value;
    if ('firstName' in formObject && 'lastName' in formObject) {
      const firstName = formObject['firstName'];
      const lastName = formObject['lastName'];
      const fullName = firstName + ' ' + lastName;
      // Remove firstName and lastName from formObject
      delete formObject['firstName'];
      delete formObject['lastName'];
      // Add fullName under name key
      formObject['name'] = fullName;
    }
    this.formSubmissionService.submitIndividualForm(
      {
        ...formObject,
      },
      '',
    );

    this.formSubmissionService.submitIndividualForm(
      {
        payload,
      },
      '',
      FormActionTypeEnum.EDIT_BENEFICIARY,
    );
  }

  private patchAddBeneficiaryForm(): void {
    const name = this.formActionStateData?.['name'].trim();
    let firstName = '';
    let lastName = '';

    if (name) {
      const fullName = name.split(' ');

      if (fullName?.length > 1) {
        lastName = fullName[fullName?.length - 1];
        firstName = fullName.slice(0, -1).join(' '); // All words except the last as given name
      } else {
        firstName = fullName[0];
      }
    }

    this.addBeneficiaryForm.patchValue({
      name: this.formActionStateData?.['name'],
      firstName: firstName,
      lastName: lastName,
      accountNumber: this.formActionStateData?.['accountNumber'],
      sortCode: this.formActionStateData?.['sortCode'],
      srd: this.formActionStateData?.['srd'] ?? '',
    });
  }

  private formatSortCode() {
    const sortCodeValue = this.addBeneficiaryForm?.get('sortCode')?.value;
    let sortCode = '';
    if (sortCodeValue) {
      sortCode = sortCodeValue.replaceAll('-', '');
    }
    return sortCode;
  }

  private getFormValuesFromState() {
    this.formAction.pipe(takeUntil(this.destroy$)).subscribe((formValues: FormActionType) => {
      this.sortCode =
        addDashesToSortCode(formValues?.formData?.['destinationIdentifier']?.['sortCode']) ?? '';
      this.accountNumber = formValues?.formData?.['destinationIdentifier']?.['accountNumber'] ?? '';
      this.name = formValues?.formData?.['name'] ?? '';
      this.srd = formValues?.formData?.['srd'] ?? '';
      const name = this.name.trim();
      if (name) {
        const fullName = name.split(' ');

        if (fullName?.length > 1) {
          this.lastName = fullName[fullName?.length - 1];
          this.firstName = fullName.slice(0, -1).join(' '); // All words except the last as given name
        } else {
          this.firstName = fullName[0];
        }
      }
    });
  }

  private copCheck(param: string) {
    if (this.payeeEnabled) {
      const formObject = this.addBeneficiaryForm.value;
      if (formObject?.['sortCode']) {
        formObject['sortCode'] = this.formatSortCode();
      }
      if (
        formObject?.['firstName'] &&
        formObject?.['lastName'] &&
        this.beneficiaryType === ACCOUNTTYPE.PERSONAL
      ) {
        // Add fullName under name key
        formObject['name'] = formObject['firstName'] + ' ' + formObject['lastName'];

        // Remove firstName and lastName from formObject
        delete formObject['firstName'];
        delete formObject['lastName'];
      }

      this.accountService
        .checkPayee(
          {
            ...formObject,
            accountType: this.beneficiaryType as ACCOUNTTYPE,
          } as Payee,
          param,
        )
        .subscribe((checkPayeeResponse: CheckPayeeResponse) => {
          this.store.dispatch(new SetCopResponseStateName(checkPayeeResponse.name));
          this.store.dispatch(new SetCopResponseStateMatchStatusCode(checkPayeeResponse.matchStatusCode));
          if (checkPayeeResponse.matchStatusCode == CheckPayeeMatchStatus.MATCHED) {
            this.router.navigateByUrl(
              `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/review-information-match-cop?flow=${param}`,
            );
          } else if (
            checkPayeeResponse.matchStatusCode == CheckPayeeMatchStatus.CLOSE_MATCH ||
            checkPayeeResponse.matchStatusCode == CheckPayeeMatchStatus.NAME_MATCHED ||
            checkPayeeResponse.matchStatusCode == CheckPayeeMatchStatus.ACCOUNT_TYPE_MISMATCH_NAME_CLOSE_MATCH
          ) {
            this.router.navigateByUrl(
              `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/review-information-close-match-cop?flow=${param}`,
            );
          } else {
            if (
              checkPayeeResponse.matchStatusCode == CheckPayeeMatchStatus.INVALID_SECONDARY_IDENTIFIER &&
              !formObject.srd
            ) {
              this.router.navigateByUrl(
                `/zones/${formatNameAsUrl(
                  APP_ZONES.PAYMENT,
                )}/review-information-secondary-identifier-required-cop?flow=${param}`,
              );
            } else {
              setNoMatchReasonFromResponse(checkPayeeResponse.matchStatusCode, this.store);
              this.router.navigateByUrl(
                `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/review-information-no-match-cop?flow=${param}`,
              );
            }
          }
        });
    } else {
      this.router.navigateByUrl(
        `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/beneficiary-address?paymentflow=${
          PaymentFlowTypes.UK_FASTER_PAYMENTS
        }`,
      );
      // // don't check the payee
      // this.router.navigateByUrl(
      //   `/zones/${formatNameAsUrl(APP_ZONES.PAYMENT)}/review-information-match?flow=${param}`,
      // );
    }
  }

  public get nestedButtonParentCss() {
    const nestedWidgetAttri = this.dataIn.widgetConfig.nestedWidgets?.['submitButton'];
    return cssToNgStyle(nestedWidgetAttri?.['nestedButtonParentCss'] ?? '');
  }
}
